import { create } from "zustand"
import { administracaoAPI } from "../../api"

interface AtributoSistemaState {
  nomeEmpresa: string
  logoEmpresa: string
  setAtributoSistema: () => Promise<void>
  erroAtributoSistema: boolean
  loadingAtributoSistema: boolean
  setErroAtributoSistema: (erro: boolean) => void
  cleanAtributoSistemaState: () => void
}

export const useAtributoSistemaStore = create<AtributoSistemaState>((set) => ({
  nomeEmpresa: "",
  logoEmpresa: "",
  erroAtributoSistema: false,
  loadingAtributoSistema: false,
  setAtributoSistema: async () => {
    set(() => ({ loadingAtributoSistema: true, erroAtributoSistema: false }))
    const result = await administracaoAPI.getAtributoSistema()
    if (result.statusCode == 200 && result.data) {
      set(() => ({ nomeEmpresa: result.data?.nomeCliente, logoEmpresa: result.data?.logoCliente }))
    }
    else {
      set(() => ({ erroAtributosSistema: true, nomeEmpresa: "", logoEmpresa: "" }))
    }
    set(() => ({ loadingAtributoSistema: false }))
  },
  setErroAtributoSistema: (erro: boolean) => {
    set(() => ({ erroAtributoSistema: erro }))
  },
  cleanAtributoSistemaState: () => {
    set(() => ({ nomeEmpresa: "", logoEmpresa: "", erroAtributosSistema: false, loadingAtributosSistema: false }))
  }
}))